module.exports = __webpack_public_path__ + "img/w3_pause_dark.137d392c.png";